import { render, staticRenderFns } from "./CompanyImprintsAddDialogComponent.vue?vue&type=template&id=1dbb04c4&scoped=true&"
import script from "./CompanyImprintsAddDialogComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyImprintsAddDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompanyImprintsAddDialogComponent.vue?vue&type=style&index=0&id=1dbb04c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbb04c4",
  null
  
)

export default component.exports